module.exports = function() {

  /**
   *  Validates an enumerable list.
   *
   *  @param cb The callback function.
   */
  this.main.enum = function enumerable(cb) {
    if(this.validates()) {
      this.required();
      var list = this.rule.list;
      if(!~list.indexOf(this.value)) {
        this.raise(
          this.reasons.enumerable,
          this.messages.enum,
          this.field, list.join(', '));
      }
    }
    cb();
  }

}



//////////////////
// WEBPACK FOOTER
// ../node_modules/async-validate/plugin/enum.js
// module id = 1372
// module chunks = 93